module.exports = {
	message: {
        // 印尼
		home: {
			language: "Bahasa indonesia",
			keyword:'Kata kunci',
			hotPro:'Produk terlaris',
			product:'Produk utama',
			about:'Tentang kita',
			aboutDesc:'Pelayanan pelanggan, kepuasan pelanggan',
			news:'Berita terkini',
			company:'teman',
			proVideo:'VIDEO promosi',
			certificate:'sertifikat',
			factory:'Pabrik komunikas'
		},
		about:{
			advantages:'Keuntungan kita',
			factory:'Tampilan pabrik',
			honors:'Kehormatan & sertifikat',
			honorsDesc:'Kami mengejar tujuannya untuk melayani anda lebih baik',
			title1:'Kapasitas produksi',
			content1:'Sepenuhnya dimiliki, besar, pabrik produksi modern',
			title2:'Harga kompetitif',
			content2:'Harga wajar, kinerja biaya tinggi',
			title3:'Kiriman kilat',
			content3:'Beberapa gudang terletak di pelabuhan muatan utama',
			title4:'Tim profesional',
			content4:'Profesional mengembangkan, memproduksi, mengekspor tim',
			free1:'Layanan yang disesuaikan',
			frcon1:'Daur ulang logam memaksudkan pemrosesan bahan yang berguna secara fisik atau mekanis, yang dipisahkan dari potongan logam menjadi produk daur ulang. Ini adalah rantai industri dari daur ulang, penguraian menjadi daur ulang. Industri daur ulang logam telah membentuk rantai industri lengkap dan daur ulang ekosistem. Ketika negara-negara emerging economy secara bertahap mengadopsi teknologi dan gaya hidup yang sama dengan negara-negara OECD, permintaan global akan logam di masa depan akan mencapai 3 sampai 9 kali jumlah logam yang digunakan di seluruh dunia. Daur ulang produk logam kompleks dapat menyelesaikan dan mengatasi tantangan yang ditimbulkan oleh lonjakan permintaan logam.',
			free2:'Kontrol kualitas',
			frcon2:'Alat daur ulang logam terutama mencakup peralatan penghancur dan pelekatan, pensortir peralatan, peralatan perawatan awal dan peralatan regenerasi, DLL. Berbagai peralatan memainkan peranan kunci dalam berbagai bidang daur ulang logam. Peralatan ini banyak digunakan untuk memproses memo logam dan meningkatkan pemanfaatan sumber daya, meliputi berbagai alat teknis seperti menghancurkan secara fisik, pemisahan magnetik, perataan, DLL.',
			free3:'Logistik One-stop',
			frcon3:'Pabrik daur ulang logam perusahaan kami, khusus menangani segala macam limbah logam dan berkomitmen untuk daur ulang dan pemurnian logam langka. Kisaran daur ulang di toko mencakup dunia, menyediakan layanan yang nyaman seperti analisis harga on-the-spot dan transaksi tunai. Perusahaan kami berfokus pada limbah logam berkualitas tinggi, yang dapat didaur ulang terlepas dari berat atau bentuk.',
			free4:'Inspeksi pihak ketiga',
			frcon4:'Selain dampak lingkungan pertambangan logam dan peleburan, juga mengkonsumsi 7% hingga 8% pasokan energi dunia. Daur ulang mengurangi energi yang terbuang dibandingkan produksi utama logam, sekaligus mengurangi dampak keseluruhan terhadap situs-situs pertambangan. Daur ulang logam juga dapat mengurangi permintaan akan bijih bermutu rendah, sehingga menghindari penambangan beberapa logam berharga yang akan langka di masa depan.',
			new1:'Berita',
			new2:'Berita perusahaan',
			new3:'Berita industri'
		},
		service:{
			ourservice:'Pelayanan kami',
			questions:'Pertanyaan yang sering diajukan',
			message:'Tinggalkan pesan',
			hours:'Silakan tinggalkan pesan. Kami akan membalas anda dalam 24 jam.',
			name:'Namamu:',
			mail:'E-Mail:*',
			tel:'Tel/Whatsapp:',
			type:'Tipe produk :*',
			video:'vide',
			up:'Halaman sebelumnya',
			next:'Halaman berikutnya'
		},
		contact:{
			help:'Kami di sini untuk membantu',
			helpDesc:'Hubungi kami melalui informasi kontak berikut',
			manager:'Manajer penjualan',
			phone:'Telepon/Whatsapp/Wechat',
			sendeamil:'Kirim Email',
			ouraddress:'Alamat kami'
		}, 
		foot:{
			navigation:'Cepat navigasi',
			type:'kategori',
			mobile:'MOBILE(WHATSAPP/WECHAT)',
			email:'Email',
			address:'alamat',
			number:'Nomor berkas',
			service:'Satu layanan berhenti, seleksi lebih mudah'
		},
		product:{
			description:'deskripsi',
			technical:'Spesifikasi teknis',
			advantages:'keuntungan',
			related:'Produk terkait',
			videoDesc:'Cina sumber pabrik besi besi, dengan kualitas tertinggi, dengan harga terendah, dengan komisi tinggi, terbuka agen.',
			ti1:'Tolong isi alamat surelnya.',
			ti2:'Tolong isi lagi.',
			ti3:'Tolong isi dulu isinya.'
		},
		nav:{
			home:'rumah',
			about:'Tentang kita',
			products:'produk',
			news:'berita',
			video:'vide',
			free:'Daur ulang & teknologi bebas',
			contact:'Hubungi kami',
			vr:'vrname',
			chat:'obrolan',
			whatsapp:'Whatsapp',
			wechat:'weobrolan',
			message:'pesan',
			tel:'Tel',
			top:'atas',
		},
		btn:{
			read:'Baca lebih lanjut',
			news:'Berita lainnya',
			exhibition:'Informasi lebih lanjut',
			watchVideo:'Tonton lebih banyak video',
			services:'layanan',
			products:'produk',
			contactus:'Hubungi kami',
			inquiry:'Cari tahu sekarang',
			size:'ukuran',
			packing:'mengemas',
			service:'Layanan daring',
			submit:'kirim',
			sendEmial:'Kirim EMAIL',
			now:'Pesanan sekarang',
			text1:'Jangan ragu untuk menghubungi kami setiap saat.',
			text2:'Kami merancang konten dan keuletan bahan yang memenuhi kebutuhan anda.',
			text3:'Apakah anda perlu meningkatkan keselamatan, memaksimalkan kapasitas produksi atau kehandalan, atau mengurangi biaya, kami sampaikan.',
			text4:'Kami berdedikasi untuk menyediakan layanan pelanggan yang luar biasa dan memberikan produk berkualitas tinggi kepada klien kami.',
			text5:'Fokus pada produksi logam silikon dan silikon berkualitas tinggi',
			text6:'* Tips: 1. Produk apa yang kau butuhkan? 2. Proyek apa yang kau rencanakan? 3. Kapan kau butuh produk ini?'
		}
    }
};
